import ShareComponent from "./ShareComponent";

export default ShareComponent;
